import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArchwayIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M22 20h-1V8h1a1 1 0 1 0 0-2h-1V3a1.0002 1.0002 0 0 0-1-1H4a1 1 0 0 0-1 1v3H2a1 1 0 0 0 0 2h1v12H2a1.0002 1.0002 0 0 0-.7071 1.7071C1.4804 21.8946 1.7348 22 2 22h20a1.0001 1.0001 0 0 0 0-2Zm-7 0H9v-3.53a6.2097 6.2097 0 0 1 3-5.33 6.21 6.21 0 0 1 3 5.33V20Zm4 0h-2v-3.53a8.17 8.17 0 0 0-4.55-7.36 1.0001 1.0001 0 0 0-.9 0A8.17 8.17 0 0 0 7 16.47V20H5V8h14v12Zm0-14H5V4h14v2Z"/>
  </SvgIcon>
}

export default LineArchwayIcon
